<ex-button
  *ngIf="!tendersActionService.selection"
  data-cy="tender-selection-toggle"
  icon="dots-three-outline-fill"
  (click)="tendersActionService.toggle(true)"
/>
<ex-button *ngIf="tendersActionService.selection" icon="x" type="secondary" variant="tonal" (click)="tendersActionService.toggle(false)" />
